export enum PreferenceCoverageEnum {
  MEDICARE_SUPPLEMENT = "Medicare Supplement (Medigap)",
  MEDICARE_ADVANTAGE = "Medicare Advantage (HMO, PPO, PFFS)",
  MEDICARE_PART_D = "Prescription Drugs (Part D)"
}
